import { defineStore } from 'pinia'
import { ref } from 'vue'
import { darkTheme } from 'naive-ui'

export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(false)

  // Alterna o tema e salva no localStorage
  function toggleTheme() {
    isDark.value = !isDark.value
    localStorage.setItem('isDark', isDark.value)
  }

  // Carrega o tema salvo (caso exista)
  function loadTheme() {
    const saved = localStorage.getItem('isDark')
    if (saved !== null) {
      isDark.value = saved === 'true'
    }
  }

  loadTheme()

  return {
    isDark,
    toggleTheme,
    themeValue: () => (isDark.value ? darkTheme : null)
  }
})
